/**
 * BookmarkIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BookmarkIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16.44 2H7.56C5.04 2 3 4.01 3 6.47v12.68c0 1.12.45 2.04 1.24 2.51.81.48 1.85.44 2.88-.11l4.5-2.44c.18-.1.59-.1.77 0l4.49 2.44c.55.3 1.11.45 1.63.45.45 0 .87-.11 1.24-.33.79-.47 1.25-1.39 1.25-2.52V6.47C20.99 4.01 18.94 2 16.44 2M19 19.15c0 .39-.1.7-.27.8-.18.11-.52.05-.9-.16l-4.49-2.43c-.39-.22-.87-.32-1.34-.32s-.95.11-1.34.32L6.17 19.8c-.37.2-.72.26-.9.15-.17-.1-.27-.4-.27-.79V6.47C5 5.11 6.15 4 7.56 4h8.88C17.85 4 19 5.11 19 6.47z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BookmarkIcon = makeIcon('BookmarkIcon', BookmarkIconSvg)
